export default __webpack_public_path__ + "static/media/harry.7d40dbea.png";